import airbrakeJs from 'airbrake-mini-client';
import { getEnvironment } from './utils/environment';

const PROJECT_ID = 196643;
const PROJECT_KEY = '4d769d5890c711ed8b76713994811434';

const airbrake = airbrakeJs({
  projectId: PROJECT_ID,
  projectKey: PROJECT_KEY,
  environment: getEnvironment(window.location.hostname)
});

let filterAll = false;

airbrake.addFilter((notice) => {
  if (filterAll) return;
  const { context } = notice;
  if (!context) return null;
  if (context.url && context.url.indexOf('file') === 0) return null;
  if (context.environment === 'unknown' || context.environment === 'local') return null;
  return notice;
});

// I am switching off airbrake when the browser is unloading
window.addEventListener('unload', () => {
  filterAll = true;
});

export default airbrake;
